import { render, staticRenderFns } from "./SideUp.vue?vue&type=template&id=286dc7e9"
import script from "./SideUp.vue?vue&type=script&lang=js"
export * from "./SideUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports